module.exports = __webpack_public_path__ + "img/err.e31e50f5.png";